<template>
  <div class="row no-gutters justify-content-center h-100">
    <div class="col-sm-12 col-md-8 col-lg-4 col-xl-4">
      <BQdtCard
        name="ratingsDimension"
        type="top-menu-item"
      />
    </div>
    <div class="col-sm-12 col-md-8 col-lg-5 col-xl-4">
      <BQdtCard
        name="ratingsIndicator"
        type="top-menu-item"
      />
    </div>
    <div class="col-sm-12 col-md-8 col-lg-3 col-xl-2">
      <BQdtCard
        name="ratingsTopN"
        type="top-menu-item"
      />
    </div>
  </div>
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'RatingsTopMenu',

  components: { BQdtCard },
}
</script>
